export default class CatalogExpConst {
  static EXP_SET = "exp-set";
  static EXP_VAL = "exp-val";  
  static EXP_FILTER = "exp-filter";  
  static EXP_FILTERLK = "exp-filterlk";  
  static EXP_DEFAULTVALUES = "exp-dfv";  
}
